module.exports = __webpack_public_path__ + "static/media/Polygon.c6fca1b4.png";